import CityPageTemplate from "../city-template/CityPageTemplate";
import { clintonConfig } from "./data";

export default function ClintonPage() {
  return <CityPageTemplate config={clintonConfig} />;
}